'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Screen = exports.ScreenRouter = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.screen = screen;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _doohUtils = require('dooh-utils');

var _doohReactUtils = require('dooh-react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScreenRouter = exports.ScreenRouter = function (_React$Component) {
  _inherits(ScreenRouter, _React$Component);

  function ScreenRouter(props) {
    _classCallCheck(this, ScreenRouter);

    var _this = _possibleConstructorReturn(this, (ScreenRouter.__proto__ || Object.getPrototypeOf(ScreenRouter)).call(this, props));

    _this.handleGotoScreen = function (screen) {
      (0, _doohUtils.activity)();

      if (screen == null) {
        console.info('No screen with ' + name + '.');
        return;
      }

      _this.props.update(function (s) {
        return _extends({}, s, { screen: screen });
      });
    };

    _this.handleGotoFirstScreen = function () {
      var screen = _this.getScreenName(_this.props.screens[0]);
      _this.props.update(function (s) {
        return _extends({}, s, { screen: screen });
      });
    };

    _this.handleGotoNextScreen = function () {
      (0, _doohUtils.activity)();

      var screens = _this.props.screens,
          i = screens.findIndex(function (s) {
        return _this.getScreenName(s) === _this.props.screen;
      });
      if (i === -1) {
        console.warning('No screen with name ' + _this.props.screen + '.');
        return;
      }
      var screen = _this.getScreenName(screens[(i + 1) % screens.length]);
      _this.props.update(function (s) {
        return _extends({}, s, { screen: screen });
      });
    };

    window.gotoScreen = _this.handleGotoScreen.bind(_this);
    return _this;
  }

  _createClass(ScreenRouter, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var ShowScreen = this.getScreen();

      return _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        {
          component: 'div',
          className: (0, _classnames2.default)('ScreenRouter', this.props.className),
          transitionName: this.props.transitionName,
          transitionEnter: this.props.animation,
          transitionEnterTimeout: this.props.enterTimeout,
          transitionLeave: this.props.animation,
          transitionLeaveTimeout: this.props.leaveTimeout,
          transitionAppear: false
        },
        _react2.default.createElement(ShowScreen, _extends({
          key: this.getScreenName(ShowScreen)
        }, this.props.screenProps || {}, {
          gotoScreen: this.handleGotoScreen,
          gotoFirstScreen: this.handleGotoFirstScreen,
          gotoNextScreen: this.handleGotoNextScreen
        })),
        !this.props.hiddenBack ? null : _react2.default.createElement(_doohReactUtils.Tap, {
          key: '_back',
          className: 'hiddenBack',
          preventDoubleTap: false,
          onTap: function onTap() {
            return _this2.handleGotoFirstScreen({}, 'hiddenBack');
          } })
      );
    }
  }, {
    key: 'getScreenName',
    value: function getScreenName(screen) {
      if (screen.screenName != null) {
        return screen.screenName;
      } else {
        throw new Error('Screen needs a name!');
      }
    }
  }, {
    key: 'getScreen',
    value: function getScreen() {
      var _this3 = this;

      var screens = this.props.screens;
      return screens.find(function (s) {
        return _this3.getScreenName(s) === _this3.props.screen;
      });
    }
  }]);

  return ScreenRouter;
}(_react2.default.Component);

ScreenRouter.defaultProps = {
  enterTimeout: 800,
  leaveTimeout: 400,
  transitionName: 'Screen--transition-fade',
  hiddenBack: false,
  animation: true
};

var Screen = exports.Screen = function (_React$Component2) {
  _inherits(Screen, _React$Component2);

  function Screen() {
    _classCallCheck(this, Screen);

    return _possibleConstructorReturn(this, (Screen.__proto__ || Object.getPrototypeOf(Screen)).apply(this, arguments));
  }

  _createClass(Screen, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('Screen', this.props.className) },
        this.props.children
      );
    }
  }]);

  return Screen;
}(_react2.default.Component);

function screen(Screen, screenName) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var NamedScreen = function (_React$Component3) {
    _inherits(NamedScreen, _React$Component3);

    function NamedScreen() {
      var _ref;

      var _temp, _this5, _ret;

      _classCallCheck(this, NamedScreen);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this5 = _possibleConstructorReturn(this, (_ref = NamedScreen.__proto__ || Object.getPrototypeOf(NamedScreen)).call.apply(_ref, [this].concat(args))), _this5), _this5.checkActivity = function () {
        if (!(0, _doohUtils.isActive)(props.timeout)) {
          if (window.track) {
            var meta = Object.assign({ screen: screenName }, _this5.props);
            window.track('timeout', meta);
          }
          _this5.props.gotoFirstScreen();
        }
      }, _temp), _possibleConstructorReturn(_this5, _ret);
    }

    _createClass(NamedScreen, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (props.timeout != null) {
          this.timeoutInterval = setInterval(this.checkActivity, 1000);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (props.timeout != null) {
          clearInterval(this.timeoutInterval);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Screen, _extends({}, props, this.props));
      }
    }]);

    return NamedScreen;
  }(_react2.default.Component);

  NamedScreen.screenName = screenName;
  ;

  NamedScreen.displayName = 'Screen(' + screenName + ')';

  return NamedScreen;
}


//////////////////
// WEBPACK FOOTER
// ./~/dooh-react-utils/dist/Screen.js
// module id = 136
// module chunks = 0